import React from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import { withProps } from 'recompose';

import { SearchBox } from 'components/search/SearchBox';
import withSearchHandler from 'decorators/withSearchHandler';

import { PSPMarkdownContent } from 'components/psp/PSPMarkdown/';
import './PSPVehicleSearch.scss';


export const enhance = compose(
	withProps(() => ({
		searchType: 'vehicle',
		additionalSearchParams: { vehicle: 'car' }
	})),
	withSearchHandler
);
export function PSPVehicleSearch({ title, handleSearch, buttonText="Find Storage" }) {

	return (
		<div className="psp-vehicle-search">
			<div className="psp-vehicle-search-content">
				<PSPMarkdownContent
					content={title}
					additionalParams={{ heading: { size: 'medium' } }}
				/>
				<div className="psp-vehicle-search-right">
					<SearchBox
						id="psp-vehicle-search-box"
						inputLabel="Enter address, city or zip"
						handleSearch={handleSearch}
						hideOnScroll
						pinkButton
						buttonText={buttonText}
					/>
				</div>
			</div>
		</div>
	);
}

PSPVehicleSearch.propTypes = {
	title: PropTypes.string.isRequired,
	handleSearch: PropTypes.func,
	buttonText: PropTypes.string
};

export default enhance(PSPVehicleSearch);